import { updateObject } from 'utils/updateObject'
import { v4 as uuidv4 } from 'uuid'
import { fromJS, List } from 'immutable'

const initialState = {
  modals: [],
}

const showModal = (state, { payload }) =>
  updateObject(state, {
    modals: [
      ...state.modals,
      {
        modalProps: {
          ...payload.modalProps,
          ...payload,
        },
        UUID: payload.UUID || uuidv4(),
        modalType: payload.modalType,
        openFrom: !!payload?.openFrom,
      },
    ],
  })

const updateModalByUUID = (state, { payload }) => {
  const currentModals = List(state.modals)
  const index = currentModals.findIndex(({ UUID }) => UUID === payload.UUID)
  currentModals.update(index, (modal) => {
    modal.modalProps = { ...modal.modalProps, ...payload.modalProps }
    return modal
  })
  return updateObject(state, { modals: currentModals.toJS() })
}

const hideModal = (state, { payload }) => {
  const currentModals = List(state.modals)
  if (payload) {
    const payloadKeys = Object.keys(payload)

    const updatedModals = currentModals.map((modal) => {
      const equalValueKeys = payloadKeys.filter(
        (key) => fromJS(modal).getIn([key]) === payload[key],
      )

      if (payloadKeys.length === equalValueKeys.length) {
        modal.closeRequest = true
      }

      return modal
    })

    return updateObject(state, { modals: updatedModals.toJS() })
  }

  const updatedModals = currentModals.map((modal) => {
    modal.closeRequest = true
    return modal
  })

  return updateObject(state, {
    modals: updatedModals.toJS(),
  })
}

const removeModal = (state, { payload }) => {
  if (payload && payload.UUID) {
    const currentModals = List(state.modals)
    const replaceIndex = currentModals.findIndex(
      ({ UUID }) => UUID === payload.UUID,
    )
    return updateObject(state, {
      modals: currentModals.splice(replaceIndex, 1).toJS(),
    })
  }

  return initialState
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'MODAL/SHOW':
      return showModal(state, action)
    case 'MODAL/HIDE':
      return hideModal(state, action)
    case 'MODAL/UPDATE_MODAL_BY_UUID':
      return updateModalByUUID(state, action)
    case 'MODAL/REMOVE':
      return removeModal(state, action)
    default:
      return state
  }
}
